export enum RouteName {
  List = 'list-price-lists',
}
